export const TRANSIT_COLUMNS = [
  {
    title: "Cylinder NO.",
    sortArrow: true,
    sortBy: "number",
    address: ["cylinder_no"],
  },
    {
    title: "Dispatch Date",
    sortArrow: true,
    sortBy: "date",
    address: ["dispatched_date"],
  },
  {
    title: "Dispatched From Station",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["dispatched_from_station"],
  },
  {
    title: "Dispatch By",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["dispatched_by"],
  },
  {
    title: "Vehicle NO.",
    sortArrow: true,
    sortBy: "number",
    address: ["vehicle_no"],
  },
];
